import React from "react";
import { Chip } from "@mui/material";
import { getBHStatusColors } from "../../constants/bhDashboard";

/**
 * Chip para mostrar un BH Health Status con colores de 7 niveles de severidad.
 *
 * @param {{ status: string, size?: "small"|"medium" }} props
 */
export default function BHStatusChip({ status, size = "small" }) {
  const colors = getBHStatusColors(status);
  return (
    <Chip
      label={status || "N/A"}
      size={size}
      sx={{
        fontWeight: 600,
        fontSize: "0.68rem",
        color: colors.text,
        bgcolor: colors.bg,
        border: `1px solid ${colors.border}`,
        maxWidth: 180,
      }}
    />
  );
}
